'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var $ = _interopDefault(require('jquery'));
var I18n = _interopDefault(require('../../global/i18n.js'));
var SignupModal = _interopDefault(require('./signup-modal.js'));

function anonymous(locals, escapeFn, include, rethrow
/*``*/) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
}var __line = 1
  , __lines = "<div class=\"signup-modal__content\">\n  <h2 class=\"modal__heading\" id=\"ModalTitle\"><%= locals.signupHeader %></h2>\n</div>\n"
  , __filename = undefined;
try {
  var __output = [], __append = __output.push.bind(__output);
 __append("<div class=\"signup-modal__content\">\n  <h2 class=\"modal__heading\" id=\"ModalTitle\">")
    ; __line = 2
    ; __append(escapeFn( locals.signupHeader ))
    ; __append("</h2>\n</div>\n")
    ; __line = 4;
  return __output.join("");
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}

/*= =============== Signup.js ================*/
// This file is the simplest way to initialize the Signup javascript for a
// Shopify marketing site, just call `new Signup()`. All inline threefield
// forms will be initialized
function Signup() {
  this.initForms();
}

Signup.prototype.initForms = function () {
  var trigger = $('.js-open-signup');
  var inlineTrigger = $('.js-signup-inline');
  if (trigger.length || inlineTrigger.length) {
    this.SignupModal = new SignupModal(trigger, anonymous.bind(this, { signupHeader: I18n.t('signup.header') }), {
      modalActiveContainerClass: 'signup-modal js-is-active',
      clickingOverlayClosesModal: false
    });
  }
};

module.exports = Signup;
